module.exports = __webpack_public_path__ + "img/44.09db9a26.png";